import React from 'react';

const LogoRTBusiness = ({ className = "h-12 w-auto" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Dégradé moderne mélangeant RT CONNECT (magenta) et MRT+ (noir/gris) */}
        <linearGradient id="rtBusinessCircleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#C8247C', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#8B1F5C', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#2a2a2a', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Cercle avec dégradé */}
      <circle 
        cx="50" 
        cy="50" 
        r="45" 
        fill="url(#rtBusinessCircleGradient)"
        stroke="none"
      />
    </svg>
  );
};

export default LogoRTBusiness;
